import { ContactReason } from '../contactrequest/contactrequest.service';

export class RequestReason {
    id: ContactReason;
    name: string;
}
